import zappy from '@zappy-ride/library.react.components';
import { VehicleDetails } from './VehicleDetails';

export * from './VehicleDetails';

zappy.FactoryInstance.registerComponent(VehicleDetails);
